<div class="auth-callback">
  <div class="hub-card auth-callback__card">
    @if (errorCode(); as code) {
      <p class="auth-callback__message auth-callback__message--error">
        {{ 'SSO.ERROR.' + code | translate }}
      </p>
      <a routerLink="/login" class="hub-link">
        {{ 'SSO.BACK_TO_LOGIN' | translate }}
      </a>
    } @else {
      <p class="auth-callback__message">
        {{ 'SSO.SIGNING_IN' | translate }}
      </p>
    }
  </div>
</div>
